import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Persistent notice shown at the very top of every page so learners always
 * know this is a practice sandbox, not a real job board.
 */
export default function DemoBanner() {
  return (
    <div
      data-testid="demo-banner"
      className="w-full bg-amber-100 border-b border-amber-300 text-amber-900 text-xs sm:text-sm py-1.5 px-4 flex items-center justify-center gap-2"
      role="note"
    >
      <AlertTriangle className="h-3.5 w-3.5 flex-shrink-0" />
      <span className="tag-mono">
        <strong>Demo practice website</strong> — this is a sandbox for learning QA &amp; automation testing.
        <span className="hidden sm:inline"> Not a real job board.</span>
      </span>
    </div>
  );
}
